import React, { Component } from 'react';
import { Button } from './index';
export default class Touchable extends Component {
    render() {
        const { onClick, disabled } = this.props;
        return (React.createElement(Button, Object.assign({ disabled: disabled, onClick: onClick, children: this.props.children }, this.props)));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/elements/Touchable.tsx
// module id = 113
// module chunks = 0